import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
import { requestLineReportsWhereabouts } from '@features/whereabouts/services/Movements';
import { MemberMovements, UsersWhereaboutsDay } from '@features/whereabouts/models/movements.models';

export interface LineReportsWhereaboutsState {
  whereabouts: MemberMovements[];
  loading: boolean;
  isLineReportOptionSelected: boolean;
}

export const initialLineReportsWhereaboutsState: LineReportsWhereaboutsState = {
  whereabouts: [],
  loading: false,
  isLineReportOptionSelected: false,
}

export const loadLineReportsWhereabouts: any = createAsyncThunk('lineReportWhereabouts/load',
  async (params: {date: string}, thunkAPI) => {
    const state = (thunkAPI.getState() as AppState);
    if (params.date && state.lineReportsWhereabouts.isLineReportOptionSelected) {
      const resp = await requestLineReportsWhereabouts(params.date);
      return resp;
    }
    return [];
  }
);

export const updateLineReportsWhereabouts: any = createAsyncThunk('lineReportsWhereabouts/updateWhereabouts',
  async (params: {whereaboutsToReplace: UsersWhereaboutsDay}, thunkAPI) => {
    const state = (thunkAPI.getState() as AppState);
    const lineReports = state.lineReportsWhereabouts.whereabouts;

    const updatedLineReportsWhereabouts = lineReports.map((lineReportWhereabouts: MemberMovements) => {
      if (lineReportWhereabouts.id === params.whereaboutsToReplace.userId) {
        const whereaboutsForDate = (lineReportWhereabouts.whereabouts ?? []).find(w => w.date === params.whereaboutsToReplace.date);
        if (whereaboutsForDate) {
          const filteredWhereabouts = (lineReportWhereabouts.whereabouts ?? []).filter(w => w.date !== params.whereaboutsToReplace.date);
          return {
            ...lineReportWhereabouts,
            whereabouts: [...filteredWhereabouts, params.whereaboutsToReplace],
          };
        } else {
          return {
            ...lineReportWhereabouts,
            whereabouts: [...lineReportWhereabouts.whereabouts, params.whereaboutsToReplace],
          }
        }
      }
      return lineReportWhereabouts;
    })

    return updatedLineReportsWhereabouts;
  }
);

const lineReportWhereaboutsSlice = createSlice({
  name: 'lineReportWhereabouts',
  initialState: initialLineReportsWhereaboutsState,
  reducers: {
    reset: () => ({...initialLineReportsWhereaboutsState}),
    setWhereaboutsLineReportSelected: (state, action) => ({...state, isLineReportOptionSelected: action.payload}),
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadLineReportsWhereabouts.pending, (state) => ({ ...state, whereabouts: [], loading: true }))
      .addCase(loadLineReportsWhereabouts.rejected, (state) => ({ ...state, whereabouts: [], loading: false }))
      .addCase(loadLineReportsWhereabouts.fulfilled, (state, action) => ({
      ...state,
      whereabouts: action.payload,
      loading: false,
    }))
      .addCase(updateLineReportsWhereabouts.fulfilled, (state, action) => ({
      ...state,
      whereabouts: action.payload,
      loading: false,
    }));
  }
})

export default lineReportWhereaboutsSlice.reducer;
export const { setWhereaboutsLineReportSelected } = lineReportWhereaboutsSlice.actions;

// Selectors
export const selectLineReportsWhereabouts = (state: AppState) => state.lineReportsWhereabouts.whereabouts;
export const selectIsLoading = (state: AppState) => state.lineReportsWhereabouts.loading;
export const selectIsLineReportOptionSelected = (state: AppState) => state.lineReportsWhereabouts.isLineReportOptionSelected;
